import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './TextButton.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { TextButtonProps, TextButtonPriority } from './types';

/** An implementation of link-like button */
export class TextButton extends React.Component<TextButtonProps> {
  static displayName = 'TextButton';
  static defaultProps: TextButtonProps = {
    priority: TextButtonPriority.link,
  };

  _textButtonRef = React.createRef<HTMLButtonElement>();

  public focus = () => {
    this._textButtonRef.current.focus();
  };

  public blur = () => {
    this._textButtonRef.current.blur();
  };

  _wrapAffix = (icon, type) => {
    return (
      <span className={classnames(classes[`${type}-icon`], classes.affixIcon)}>
        {icon}
      </span>
    );
  };

  _getAffixes = () => {
    const { prefixIcon, suffixIcon } = this.props;
    const hasIcons = prefixIcon || suffixIcon;

    return hasIcons
      ? {
          prefixIcon: prefixIcon
            ? this._wrapAffix(prefixIcon, 'prefix')
            : undefined,
          suffixIcon: suffixIcon
            ? this._wrapAffix(suffixIcon, 'suffix')
            : undefined,
        }
      : null;
  };

  render() {
    const { priority, className, hoverStyle, ...rest } = this.props;
    const affixes = this._getAffixes();

    return (
      <TPAComponentsConsumer>
        {({ mobile }) => (
          <ButtonNext
            ref={this._textButtonRef}
            {...rest}
            className={st(
              classes.root,
              { priority, mobile, hoverStyle },
              className,
            )}
            data-mobile={mobile}
            data-priority={priority}
            {...affixes}
          />
        )}
      </TPAComponentsConsumer>
    );
  }
}
